import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";

const operationsSlice = createSlice({
  name: "operations",
  initialState: {
    cycles: [],
    currentCycleId: null,
    currentConnectionPair: null,
    currentOperationId: null,
    status: "idle",
    error: null,
  },
  reducers: {
    setCurrentCycle: (state, action) => {
      const { currentCycleId } = action.payload;
      state.currentCycleId = currentCycleId;
    },
    setCurrentOperation: (state, action) => {
      const { currentOperationId } = action.payload;
      state.currentOperationId = currentOperationId;
    },
    setCurrentConnectionPair: (state, action) => {
      const { currentConnectionPair } = action.payload;
      state.currentConnectionPair = currentConnectionPair;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOperations.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchOperations.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchOperations.fulfilled, (state, action) => {
        state.status = "loaded";
        state.cycles = action.payload;
      });
  },
});

export const fetchOperations = createAsyncThunk(
  "operations/fetchOperations",
  async () => {
    const response = await axios.get("/operations/cycles");
    return response.data;
  }
);

export const {
  setCurrentCycle,
  setCurrentOperation,
  setCurrentConnectionPair,
} = operationsSlice.actions;
export const selectCurrentCycleId = (state) =>
  state.sessionInfo.operations?.currentCycleId;
export const selectCurrentCycleName = (state) => {
  return state.sessionInfo.operations.cycles.find(
    (op) => op.operationId == state.sessionInfo.operations.currentCycleId
  ).cycleName;
};
export const selectCurrentOperationId = (state) =>
  state.sessionInfo.operations.currentOperationId;
export const selectCurrentOperationName = (state) => {
  if (
    state.sessionInfo.operations.currentCycleId == null ||
    state.sessionInfo.operations.currentOperationId == null
  )
    return null;
  return state.sessionInfo.operations.cycles
    .find(
      (cycle) => cycle.cycleId == state.sessionInfo.operations.currentCycleId
    )
    .operations.find(
      (operation) =>
        operation.operationId == state.sessionInfo.operations.currentOperationId
    ).name;
};
export const selectCycles = (state) => state.sessionInfo.operations.cycles;
export const selectOperationsStatus = (state) =>
  state.sessionInfo.operations.status;
export const selectCurrentOperations = (state) => {
  return state.sessionInfo.operations.cycles.find(
    (op) => op.cycleId == state.sessionInfo.operations.currentCycleId
  )?.operations;
};
export const selectCurrentConnectionPair = (state) =>
  state.sessionInfo.operations.currentConnectionPair;
export default operationsSlice.reducer;

/*
operations: [{ operationId: null, operationName: null, operations: [] }]
operations [{ name:null, nameLine1: null, nameLine2: null, iconInactive: null, iconHover: null, iconClicked: null,
    sourceArtifact: null, targetArtifact: null}]
connectionPair: [{{
    "id": "1",
    "connectionPairId": 1,
    "connectionPairName": "CYTEST Connection Pair",
    "connectionId1": 4,
    "connectionId2": 5,
    "connectionProfiles": [],
    "connection_ConnectionId1": null,
    "connection_ConnectionId2": null
}}]
*/
